module.exports = __webpack_public_path__ + "static/media/dt_blast_quiz.b9864dd1.png";